import { useUpdateMany } from '@refinedev/core';

const useSetFeaturedPackages = () => {
  const { mutateAsync: updateManyAsync } = useUpdateMany();

  const setFeaturedPackages = async ({
    ids,
    onFinish,
    onError
  }: {
    ids: string[];
    onFinish?: () => void;
    onError?: (e) => void;
  }) => {
    try {
      await updateManyAsync({
        resource: 'flex_packages',
        ids: ids,
        values: { featured: true }
      });
    } catch (e) {
      onError?.(e);
    } finally {
      onFinish?.();
    }
  };

  return setFeaturedPackages;
};

export default useSetFeaturedPackages;
